var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('eden-page-header',{attrs:{"title":'Service Partners',"subtitle":`${_vm.form.organization_name}`,"section":'Edit Profile'}}),_c('service-partner-form',{attrs:{"service-partner":_vm.form,"action":"edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }